import React from 'react'
import PropTypes from 'prop-types'
import './Button.css'

function Button({ children, close, next, selected, shape, variant, ...props }) {
  let className = 'quiz-button'
  switch (variant) {
    case 'blue':
      className += ' quiz-button-blue'
      break
    case 'grey':
      className += ' quiz-button-grey'
      break
    default:
      className += ' quiz-button-default'
      break
  }
  switch (shape) {
    case 'round':
      className += ' quiz-button-round'
      break
    default:
      break
  }
  if (props.disabled) {
    className += ' quiz-button-disabled'
  }
  return (
    <button className={className} {...props}>
      {children}
    </button>
  )
}

Button.defaultProps = {
  children: 'Button text',
  onClick: () => null,
  selected: false,
}

Button.propTypes = {
  children: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  text: PropTypes.string,
  width: PropTypes.number,
}

export default Button
